import BookingStatusBadge from './BookingStatusBadge';
import { formatDate, DATE } from '@koob/dates';

const LinkedBookingHotels = ({ hotels, title }) => {
  if (!hotels?.length) return null;
  const sortedHotels = [...hotels].sort((a, b) => {
    return new Date(a.startAt).getTime() - new Date(b.startAt).getTime();
  });

  return (
    <div className="mt-4">
      <div className="border border-gray-200 rounded-lg p-4 max-h-[300px] overflow-y-auto">
        <div className="flex justify-between items-center mb-2.5 pb-2.5 border-b border-gray-200">
          <strong className="text-gray-700">{title}</strong>
        </div>

        <div className="flex flex-col gap-2.5">
          {sortedHotels.map((hotel, index) => (
            <div
              key={hotel.bookingId ?? index}
              className="p-3 rounded-2xl border border-solid border-k-gray bg-white hover:border-navy-200 transition-colors"
            >
              <div className="flex items-center justify-between w-full">
                <div className="text-left">
                  <div className="font-medium">{hotel.hotelName}</div>
                  <div className="text-xs text-gray-400 mt-1">
                    {`${formatDate(hotel.startAt, DATE)} - ${formatDate(
                      hotel.endAt,
                      DATE,
                    )}`}
                  </div>
                </div>

                <BookingStatusBadge status={hotel.state} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LinkedBookingHotels;
